import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["eyes"]
  static eyesReach = 0.4
  static eyesHeight = { top: 0.5, bottom: 0.6 }

  connect() {
    this.header = this.element.closest(".public-header-bar")
    this.motion = window.matchMedia("(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) and (forced-colors: none)")
    this.resetOnChange = () => this.reset()
    this.motion.addEventListener("change", this.resetOnChange)
    this.reset()
  }

  disconnect() {
    this.motion.removeEventListener("change", this.resetOnChange)
    this.hide()
  }

  wake(event) {
    if (event.pointerType !== "mouse" || !window.matchMedia("(hover: hover) and (pointer: fine) and (forced-colors: none)").matches) return

    this.element.setAttribute("data-wordmark-awake", "")
    this.look(event)
  }

  look(event) {
    if (event.pointerType !== "mouse" || !this.element.hasAttribute("data-wordmark-awake")) return

    this.pointer = { x: event.clientX, y: event.clientY }
    if (this.frame) return

    this.frame = requestAnimationFrame(() => {
      this.frame = null
      const header = this.header.getBoundingClientRect()
      if (this.pointer.y < header.top || this.pointer.y >= header.bottom) {
        this.hide()
        return
      }
      if (!this.motion.matches) return

      this.position(this.pointer.x, (this.pointer.y - header.top) / header.height)
    })
  }

  position(x, y) {
    const bounds = this.eyesTarget.getBoundingClientRect()
    const eye = parseFloat(getComputedStyle(this.eyesTarget).getPropertyValue("--eye"))
    const { eyesReach, eyesHeight } = this.constructor
    const eyesX = clamp(x - bounds.left, -eyesReach * eye, bounds.width + eyesReach * eye)
    const eyesY = clamp(y, eyesHeight.top, eyesHeight.bottom)
    this.eyesTarget.style.setProperty("--eyes-x", `${eyesX}px`)
    this.eyesTarget.style.setProperty("--eyes-y", `${eyesY * 100}%`)
    this.eyesTarget.style.setProperty("--pupils-x", `${x - bounds.left}px`)
    this.eyesTarget.style.setProperty("--pupils-y", `${y * 100}%`)
  }

  hide() {
    this.stop()
    this.element.removeAttribute("data-wordmark-awake")
  }

  stop() {
    cancelAnimationFrame(this.frame)
    this.frame = null
  }

  reset() {
    this.stop()
    const letters = this.eyesTarget.getBoundingClientRect()
    this.position(letters.left + letters.width / 2, 0.55)
  }
}

const clamp = (value, min, max) => Math.max(min, Math.min(max, value))
